import React from 'react'
import { isUndefined } from 'lodash'
import IntlMessages from 'util/IntlMessages';
export default function TextComponent(props) {
  return (
    <div className='d-flex align-items-center justify-content-center w-100 h-100'>
      <h1 className='m-0 font-weight-bold text-center' style={{
        color: isUndefined(props.FontColor)?"#fff":`${props.FontColor}`,
        fontSize: isUndefined(props.textSize) ? 50 : props.textSize}}>{isUndefined(props.text) ? <IntlMessages id="Input.Text.label"/> : props.text}</h1>
    </div>
  )
}
